import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { abortController } from 'store/utils';
import { getMetroApi } from './api';
const initialState = {
    map: null,
};
const actions = {
    getMetro: async (payload, { setState }) => {
        try {
            const metroCode = payload?.metroCode ?? 'dubai_metro';
            const includePlanned = payload?.includePlanned ?? 1;
            const { data } = await getMetroApi({ metroCode, includePlanned });
            setState((state) => {
                state.map = data;
            });
            return data;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
};
const store = { ...initialState, ...actions };
export default create()(devtools(immer((set, get) => abortController(store, set, get, 'Metro')), { name: 'Metro' }));
